import { useApolloClient, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { LOGOUT } from 'services/auth';
import { removeToken } from 'utils/token';

export function useLogout() {
  const apolloClient = useApolloClient();
  const [logoutMutation] = useMutation(LOGOUT);

  return useCallback(async () => {
    try {
      await logoutMutation();
      await apolloClient.cache.reset();
    } finally {
      removeToken();
      document?.location?.reload();
    }
  }, [apolloClient.cache, logoutMutation]);
}
